<template>
  <div class="container">
    <Header @input="input"></Header>
    <div class="main pr pt68 flex">
      <Mine></Mine>
      <div class="right_part flex-grow-1 ml20">
        <div class="mt10 lh28 fs20 fwb mb50">
          <span class="col6">我的订单/</span>
          <span class="col3">订单详情</span>
        </div>
        <div class="flex plr35 state_part mb30">
          <div class="flex-grow-1">
            <img class="state_icon" src="../assets/static/icon/orderProgress_on.png" alt="" />
            <div class="tc fs14 lh20 col0c">待支付</div>
          </div>
          <div :class="true ? 'line1_on' : 'line1'"></div>
          <div class="flex-grow-1">
            <img v-if="data.state > 0" class="state_icon" src="../assets/static/icon/orderProgress_on.png" alt="" />
            <img v-else class="state_icon" src="../assets/static/icon/orderProgress.png" alt="" />
            <div class="tc fs14 lh20" :class="data.state >= 1 ? 'col0c' : 'col3_5'">
              待发货
            </div>
          </div>
          <div :class="data.state > 1 ? 'line2_on' : 'line2'"></div>
          <div class="flex-grow-1">
            <img v-if="data.state > 1" class="state_icon" src="../assets/static/icon/orderProgress_on.png" alt="" />
            <img v-else class="state_icon" src="../assets/static/icon/orderProgress.png" alt="" />
            <div class="tc fs14 lh20" :class="data.state > 2 ? 'col0c' : 'col3_5'">
              已发货
            </div>
          </div>
          <div :class="data.state > 2 ? 'line3_on' : 'line3'"></div>
          <div class="flex-grow-1">
            <img v-if="data.state > 3" class="state_icon" src="../assets/static/icon/orderProgress_on.png" alt="" />
            <img v-else class="state_icon" src="../assets/static/icon/orderProgress.png" alt="" />
            <div class="tc fs14 lh20" :class="data.state > 3 ? 'col0c' : 'col3_5'">
              已完成
            </div>
          </div>
        </div>
        <div class="tc fs20 col6 lh28 mb30">{{ data.state_text }}</div>
        <div class="fs20 col3 fwb lh28 mb30 plr10">订单信息</div>
        <div class="flex flex-between fs14 col3 plr10 mb25 lh20">
          <div class="col3">订单号: {{ data.order_no }}</div>
          <div>下单时间: {{ data.createtime_text }}</div>
        </div>
        <div class="fs14 col3 lh20 mb40 plr10">支付方式：{{ data.pay_type == 1 ? '微信支付' : '支付宝支付' }}</div>
        <div class="fs20 col10 fwb lh40 plr10 mb15">收货地址</div>
        <div class="fs15 col10 fwb lh28 plr10 mb5">
          {{ data.order_address.Area.province + data.order_address.Area.city + data.order_address.Area.region }}{{
            data.order_address.address_detail }}
        </div>
        <div class="plr10 fs14 col80 lh28 mb50">
          <span class="fs14 col89 mr60">{{ data.order_address.name }}</span>
          <span>{{ data.order_address.mobile }}</span>
        </div>
        <div class="fs20 col10 fwb lh40 mb15">您购买的商品</div>
        <div v-for="(item, index) in data.order_goods" class="ptb20 flex product">
          <img class="img" :src="item.image + w500" alt="" />
          <div class="flex-grow-1">
            <div class="fs20 col10 fwb lh44 m-ellipsis">
              {{ item.goods_name }}
            </div>
            <div class="fs20 col10 fwb lh44 mb5">RMB {{ item.sku_price }}</div>
            <div class="flex-box">
              <div class="flex-grow-1 fs18 col85">{{ item.sku_title }} * {{ item.total_num }}</div>
              <div @click="jijian(index)" v-if="item.refund_id > 0 || item.refund_num > 0"
                class="colb fs14 tc label_sh cursor">
                <template v-if="item.refund_status == '-2'">已撤销</template>
                <template v-if="item.refund_status == '-1'">卖家拒绝</template>
                <template v-if="item.refund_status == '0'">已申请</template>
                <template v-if="item.refund_status == '1'">一键寄回</template>
                <template v-if="item.refund_status == '2'">已提交物流</template>
                <template v-if="item.refund_status == '3'">成功退款</template>
                <template v-if="item.refund_status == '4'">退款关闭</template>
              </div>
              <div @click="toAfterSales(item.id)"
                v-if="item.refund_id == 0 && item.refund_num == 0 && data.pay_status == '1' && item.is_bind != 1"
                class="colb fs14 tc label_sh cursor">
                申请售后
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="ptb20 border_t flex product">
          <img class="img" src="../assets/static/images/device1.png" alt="" />
          <div class="flex-grow-1">
            <div class="fs20 col10 fwb lh44 m-ellipsis">
              DrArrivo 家用脸面部提拉紧致微电流 宙斯二代美容仪
            </div>
            <div class="fs20 col10 fwb lh44 mb5">RMB 7,999</div>
            <div class="flex-box">
              <div class="flex-grow-1 fs18 col85">黑色*1</div>
              <div class="colb fs14 tc label_sh cursor">申请售后</div>
            </div>
          </div>
        </div> -->
        <div class="border_t pt20 pl223">
          <div class="flex-box">
            <div class="fs16 col85 lh22">订单金额</div>
            <div class="flex-grow-1 fs16 col10 fwb lh40 tr">RMB {{ data.total_price }}</div>
          </div>
          <div class="flex-box">
            <div class="fs16 col85 lh24">优惠</div>
            <div class="flex-grow-1 fs16 col10 fwb lh40 tr">RMB {{ data.coupon_price }}</div>
          </div>
          <div class="border_t flex-box mb40">
            <div class="fs18 col10 fwb lh44">总计</div>
            <div class="flex-grow-1 tr fs18 col10 fwb lh44">RMB {{ data.pay_price }}</div>
          </div>
          <div class="flex-box flex-end mb50">
            <template v-if="data.state == '0'">
              <div @click="cancel" class="btn_buy1 col9 tc fs18 ml40 cursor">取消订单</div>
              <div @click="toPay" class="fs18 colf tc btn_buy2 ml40 cursor">立即支付</div>
            </template>
            <template v-if="data.state == '2' || data.state == '3'">
              <!-- <div @click="toWuliu" class="btn_buy1 btn_buy3 tc fs18 ml40 cursor">查看物流</div> -->
              <div @click="complete" class="fs18 colf tc btn_buy2 ml40 cursor">确认收货</div>
            </template>
            <template v-if="data.state == '4' && data.is_bind == 0">
              <div @click="sure_bind" class="fs18 colf tc btn_buy2 ml40 cursor">绑定设备和ACARE</div>
            </template>
          </div>
        </div>
        <div></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { useHead } from "@unhead/vue";
import axios from "@/axios";
import router from "@/router";
import { getCurrentInstance } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  name: "index",

  setup() {
    useHead({
      title: "订单详情",
      meta: [
        { name: "description", content: "This is my page description" },
        { property: "og:title", content: "My Page Title" },
        { property: "og:description", content: "This is my page description" },
        { property: "og:url", content: "https://example.com/my-page" },
        { property: "og:image", content: "https://example.com/my-image.jpg" },
      ],
      link: [{ rel: "canonical", href: "https://example.com/my-page" }],
    });
  },
  data() {
    return {
      oss: getCurrentInstance().appContext.config.globalProperties.$oss,
      w1000: getCurrentInstance().appContext.config.globalProperties.$w1000,
      w500: getCurrentInstance().appContext.config.globalProperties.$w500,
      state: 3, //0待支付  1待发货  2待收货  3已完成
      data: { order_address: { Area: '' } },
      order_id: '',
    };
  },
  created() {
    this.order_id = this.$route.params.order_id
    this.getDetail()
  },
  methods: {
    getDetail() {
      axios.post('xilushop/order/order_detail', {
        type: 1,
        order_id: this.order_id,
      })
        .then(res => {
          if (res.code == 1) {
            res.data.coupon_price = parseFloat(res.data.coupon_price)
            res.data.total_price = parseFloat(res.data.total_price)
            res.data.pay_price = parseFloat(res.data.pay_price)
            this.data = res.data
          } else {
            ElMessage.error(res.msg)
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    toPay(){

    },
    cancel() {
      ElMessageBox.confirm('确认取消订单？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 确定按钮被点击的回调
        console.log('确定按钮被点击');
        axios.post('xilushop/order/cancel', {
          order_id: this.order_id
        }).then(res => {
          if (res.code == 1) {
            this.getDetail()
            ElMessageBox.alert(res.msg, '提示', {
              confirmButtonText: '确定',
            });
          } else {
            ElMessageBox.alert(res.msg, '提示', {
              confirmButtonText: '确定',
            });
          }
        })
      });
    },
    toAfterSales(id) {
      router.push({
        name: 'orderApplyAfterSales', params: {
          order_id: this.order_id,
          order_goods_id: id
        }
      })
    },
    toWuliu() {
      // uni.navigateTo({
      //   url: '/pages/logistics/logistics?express_no=' + this.data.express_no
      // })
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background: #f6f6f6;
  width: 100vw;
}

.main {
  width: 1200px;
  margin: 20px auto;
}

.mw200 {
  max-width: 200px;
}

.border_b {
  border-bottom: 1px solid #eeeff0;
}

.right_part {
  background: #fdfdfd;
  border-radius: 13px;
  overflow: hidden;
  padding: 25px 20px;

  .state_part {
    position: relative;
  }

  .state_icon {
    width: 22px;
    height: 22px;
    display: block;
    object-fit: cover;
    margin: 0 auto 5px;
    position: relative;
    z-index: 2;
  }

  .line1_on,
  .line1,
  .line2,
  .line2_on,
  .line3_on,
  .line3 {
    width: 153px;
    height: 1px;
    background: #0c0c0c;
    position: absolute;
    z-index: 2;
    top: 10px;
    left: 130px;
  }

  .line1,
  .line2,
  .line3 {
    background-color: #bcbcbc;
  }

  .line2_on,
  .line2 {
    left: 302px;
  }

  .line3_on,
  .line3 {
    right: 132px;
    left: unset;
  }

  .border_t {
    border-top: 1px solid #e3e3e3;
  }

  .img {
    width: 129px;
    height: 129px;
    display: block;
    object-fit: cover;
    margin-right: 28px;
  }

  .mb8 {
    margin-bottom: 8px;
  }

  .pl223 {
    padding-left: 149px;
  }

  .pb37 {
    padding-bottom: 37px;
  }

  .btn_buy1,
  .btn_buy2,
  .btn_buy3 {
    width: 158px;
    height: 55px;
    line-height: 55px;
    background: #bba17b;
    border-radius: 5px;
  }

  .btn_buy1,
  .btn_buy3 {
    background: #fff;
    line-height: 53px;
    border: 1px solid #e4e4e4;
  }

  .btn_buy3 {
    border-color: #bba17b;
    color: #bba17b;
  }

  .label_sh {
    width: 69px;
    text-align: center;
    height: 23px;
    line-height: 23px;
    background: #f0f0f7;
    border-radius: 12px;
  }
}
</style>